import httpClient from "./httpClient";

export function getBkashConfigStatus() {
  return httpClient.get("/bkash/config").then((res) => res.data.data);
}

export function saveBkashConfig(payload) {
  return httpClient.post("/bkash/config", payload).then((res) => res.data.data);
}
